import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputNumberMask } from '../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';

export const HealthOutOfPocketLimit = () => {
  const formBag = useFormContext<FormFields>();

  return (
    <Controller
      control={formBag.control}
      name="HealthOutOfPocketLimit"
      render={({ field: { onChange, ...field } }) => (
        <InputNumberMask
          {...field}
          label="Out-of-Pocket Limit"
          decimalScale={2}
          allowNegative={false}
          leftIcon="far fa-dollar-sign"
          innerText="/year"
          maxLength={14}
          onValueChange={({ floatValue }) => onChange(floatValue ?? null)}
        />
      )}
    />
  );
};
